import { render } from "./ContosConta.vue?vue&type=template&id=095311f0&scoped=true"
import script from "./ContosConta.vue?vue&type=script&lang=js"
export * from "./ContosConta.vue?vue&type=script&lang=js"

import "./ContosConta.vue?vue&type=style&index=0&id=095311f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095311f0"]])

export default __exports__